var _rect, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _ellipse2, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#FFFAF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3044 45.0865V55.2216C50.3044 56.0642 49.9696 56.8723 49.3738 57.4682C48.778 58.064 47.9699 58.3987 47.1272 58.3987H17.474C16.6314 58.3987 15.8233 58.064 15.2274 57.4682C14.6316 56.8723 14.2969 56.0642 14.2969 55.2216V45.0865C14.2977 44.0756 14.66 43.0982 15.3184 42.3311C15.9768 41.5639 16.8879 41.0575 17.887 40.9033L28.0644 39.3359L30.3943 41.0834C30.9443 41.4958 31.6132 41.7188 32.3006 41.7188C32.9881 41.7188 33.657 41.4958 34.2069 41.0834L36.5368 39.3359L46.7142 40.9033C47.7134 41.0575 48.6244 41.5639 49.2828 42.3311C49.9412 43.0982 50.3036 44.0756 50.3044 45.0865Z",
    fill: "#2D3749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3002 17.0635C27.3192 17.0635 23.2812 21.1014 23.2812 26.0824V29.3621C23.2812 32.8669 25.2804 35.9048 28.2007 37.3976V40.3514L30.4554 42.514C30.9876 43.0245 31.6349 43.3004 32.3002 43.3004C32.9655 43.3004 33.6128 43.0245 34.145 42.514L36.3997 40.3514V37.3976C39.32 35.9048 41.3192 32.8669 41.3192 29.3621V26.0824C41.3192 21.1014 37.2812 17.0635 32.3002 17.0635Z",
    fill: "url(#paint0_linear_19006_205812)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.096 33.7854C45.5906 33.5793 46.0983 33.9714 46.0983 34.5072V38.8132C46.0983 39.8441 46.934 40.6797 47.9649 40.6797C48.9957 40.6797 49.8314 39.8441 49.8314 38.8132V34.5062C49.8314 33.9705 50.3389 33.5784 50.8335 33.7843C53.5338 34.9084 55.4322 37.5725 55.4322 40.6799C55.4322 43.7331 53.5995 46.3583 50.9742 47.5153L51.4523 54.6869C51.5867 56.7027 49.9878 58.4117 47.9675 58.4117C45.9473 58.4117 44.3484 56.7027 44.4828 54.6869L44.9608 47.5165C42.334 46.3601 40.5 43.7342 40.5 40.6799C40.5 37.5735 42.3971 34.9102 45.096 33.7854Z",
    fill: "#ADBAD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3021 12.3154C26.7044 12.3154 22.1667 16.8541 22.1667 22.4523C22.1667 22.7186 22.1772 22.9849 22.1975 23.2483C24.0062 22.0962 27.8401 21.2915 32.2855 21.2915C36.7551 21.2915 40.6092 22.0991 42.4053 23.2627C42.4266 22.9935 42.4375 22.7243 42.4375 22.4523C42.4375 16.8541 37.8999 12.3154 32.3021 12.3154Z",
    fill: "#FF9500"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.2181,
    cy: 3.46192,
    rx: 11.2181,
    ry: 3.46192,
    transform: "matrix(-1 0 0 1 43.5195 21.1875)",
    fill: "#FF9500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.182 24.2422C23.182 25.3567 27.2652 26.2602 32.3019 26.2602C37.3387 26.2602 41.4219 25.3567 41.4219 24.2422",
    stroke: "#E17700",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3633 12.3076H29.2329V20.1897C29.2329 21.8826 30.6052 23.2549 32.2981 23.2549C33.991 23.2549 35.3633 21.8826 35.3633 20.1897V12.3076Z",
    fill: "#E17700"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.06518,
    cy: 1.90608,
    rx: 3.06518,
    ry: 1.90608,
    transform: "matrix(-1 0 0 1 35.3633 10.4072)",
    fill: "#E17700"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.44608,
    height: 1.66728,
    rx: 0.4,
    transform: "matrix(-1 0 0 1 34.5234 16.0186)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.5576,
    height: 1.66728,
    rx: 0.4,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 33.1328 20.4717)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19006_205812",
    x1: 32.3002,
    y1: 17.0635,
    x2: 32.3002,
    y2: 43.3004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB29A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrew);
export default __webpack_public_path__ + "static/media/crew.4b12d9ea4cb444adbf1f477c93d472ad.svg";
export { ForwardRef as ReactComponent };